// third-party
import { FormattedMessage } from 'react-intl';

// assets
import {
    IconDashboard,
    IconDeviceAnalytics,
    IconChartArcs,
    IconBorderAll,
    IconClipboardList,
    IconLanguage,
    IconMessages,
    IconPrompt,
    IconRobot,
    IconBook2
} from '@tabler/icons-react';

const icons = {
    IconDashboard,
    IconDeviceAnalytics,
    IconChartArcs,
    IconBorderAll,
    IconClipboardList,
    IconLanguage,
    IconMessages,
    IconPrompt,
    IconRobot,
    IconBook2
};

// ==============================|| MENU ITEMS - WORKSPACE (Kiến trúc mới: cửa vào theo project) ||============================== //
// Từ đây vào từng dự án → Files, Big Data/Lakehouse, CV, Airflow, API Gateway, Jupyter Lab

const workspace = {
    id: 'workspace-project-storage',
    title: 'Dự án & Workspace',
    icon: icons.IconDashboard,
    type: 'group',
    children: [
        {
            id: 'project-storage',
            title: 'Dự án & Kho lưu trữ',
            type: 'item',
            url: '/workspace/storage',
            icon: icons.IconClipboardList,
            breadcrumbs: false
        },
        {
            id: 'agent-hub',
            title: 'Agent Hub (Claude)',
            type: 'item',
            url: '/workspace/agent-hub',
            icon: icons.IconRobot,
            breadcrumbs: false
        },
        {
            id: 'knowledge',
            title: 'Knowledge — Hỏi đáp tài liệu',
            type: 'item',
            url: '/workspace/knowledge',
            icon: icons.IconBook2,
            breadcrumbs: false
        }
        // {
        //     id: 'document',
        //     title: <FormattedMessage id="document" />,
        //     type: 'item',
        //     url: '/workspace/document',
        //     icon: icons.IconChartArcs,
        //     breadcrumbs: false
        // },
        // {
        //     id: 'translation',
        //     title: <FormattedMessage id="translation" />,
        //     type: 'item',
        //     url: '/workspace/translation',
        //     icon: icons.IconLanguage,
        //     breadcrumbs: false
        // },
        // {
        //     id: 'prompt_engineer',
        //     title: <FormattedMessage id="prompt_engineer" />,
        //     type: 'collapse',
        //     icon: icons.IconPrompt,
        //     breadcrumbs: false,
        //     children: [
        //         {
        //             id: 'education',
        //             title: <FormattedMessage id="education" />,
        //             type: 'item',
        //             url: '/workspace/prompt_engineer/education',
        //             breadcrumbs: false
        //         },
        //         {
        //             id: 'foreign_language',
        //             title: <FormattedMessage id="foreign_language" />,
        //             type: 'item',
        //             url: '/workspace/prompt_engineer/foreign_language',
        //             breadcrumbs: false
        //         },
        //         {
        //             id: 'marketing',
        //             title: <FormattedMessage id="marketing" />,
        //             type: 'item',
        //             url: '/workspace/prompt_engineer/marketing',
        //             breadcrumbs: false
        //         },
        //         {
        //             id: 'business',
        //             title: <FormattedMessage id="business" />,
        //             type: 'item',
        //             url: '/workspace/prompt_engineer/business',
        //             breadcrumbs: false
        //         },
        //         {
        //             id: 'manage',
        //             title: <FormattedMessage id="manage" />,
        //             type: 'item',
        //             url: '/workspace/prompt_engineer/manage',
        //             breadcrumbs: false
        //         },
        //         {
        //             id: 'finance',
        //             title: <FormattedMessage id="finance" />,
        //             type: 'item',
        //             url: '/workspace/prompt_engineer/finance',
        //             breadcrumbs: false
        //         },
        //     ]
        // }
        // {
        //     id: 'mindmap',
        //     title: <FormattedMessage id="mindmap" />,
        //     type: 'item',
        //     url: '/workspace/mindmap',
        //     icon: icons.IconBorderAll,
        //     breadcrumbs: false
        // }
    ]
};

export default workspace;
